/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_Relation_CompetitorInputs */

const en_site_relation_competitor = /** @type {(inputs: Site_Relation_CompetitorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Competitor`)
};

const id_site_relation_competitor = /** @type {(inputs: Site_Relation_CompetitorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesaing`)
};

/**
* | output |
* | --- |
* | "Competitor" |
*
* @param {Site_Relation_CompetitorInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const site_relation_competitor = /** @type {((inputs?: Site_Relation_CompetitorInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_Relation_CompetitorInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_site_relation_competitor(inputs)
	return en_site_relation_competitor(inputs)
});